export default __webpack_public_path__ + "static/media/earn.11e05a09.svg";